export class AnnouncementRequest {
	ClientName: string;
	GroupName: string;
	App: string;

	constructor() {
		this.ClientName = "";
		this.GroupName = "";
		this.App = "";
	}
};